import { useQuery } from "@tanstack/react-query";
import type { ApiError } from "../api";
import api from "../api";
import type { paths } from "../types/api.types";
import urls from "../urls";

type InstallmentCalculationResponse =
  paths["/api/advance-payments-calculate/{UUID}"]["get"]["responses"]["200"]["content"]["application/json"];

export function useInstallmentCalculation(
  year: number,
  contractId: string,
  enabled: boolean
) {
  const { data, isLoading, error } = useQuery<number, ApiError<Array<string>>>({
    queryKey: ["installment-calculation", { year, contractId }],
    queryFn: () => fetchInstallmentCalculation(contractId, year),
    enabled: enabled,
    retry: false
  });

  return { data, isLoading, error };
}

async function fetchInstallmentCalculation(contractId: string, year: number) {
  const response = await api.get<InstallmentCalculationResponse>(
    urls.apiWithoutCamelization.advancePaymentsCalculate(contractId, year)
  );
  return response.data.installment;
}
